import normalize, { hiddenTagListSchema } from 'schema';
import {
  GET_HIDDEN_TAGS,
  GET_HIDDEN_TAGS_SUCCESS,
  DELETE_HIDDEN_TAG,
  HIDE_TAGS,
} from 'actionTypes';

export function getHiddenTags() {
  return {
    type: GET_HIDDEN_TAGS,
  };
}

export function getHiddenTagsSuccess(response) {
  let normalizedData;
  if (response.payload.length) {
    normalizedData = normalize(response.payload, hiddenTagListSchema);
  } else {
    normalizedData = { entities: { hiddenTags: {} } };
  }
  return {
    type: GET_HIDDEN_TAGS_SUCCESS,
    normalizedData: normalizedData,
  };
}

export function deleteHiddenTag(hiddenTagId) {
  return {
    type: DELETE_HIDDEN_TAG,
    endpointArgs: { id: hiddenTagId },
  };
}

export function hideTags(hiddenTags) {
  return {
    type: HIDE_TAGS,
    hiddenTags,
  };
}



// WEBPACK FOOTER //
// ./src/actions/hiddenTagActions.js